import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  padding-bottom: 12px;
  border-bottom: 1px solid ${Colors.Neutral15};
`

export const EmailNotificationText = styled.div`
  ${FontWeights.Medium}
  ${Typography.Body}
  color: ${Colors.Neutral90};
`

export const EnabledText = styled.div`
  ${FontWeights.Regular}
  ${Typography.Caption}
  color: ${Colors.Neutral50};
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Button = styled.div`
  ${FontWeights.Medium}
  ${Typography.Body}
  color: ${Colors.Blue50};
  white-space: nowrap;
  cursor: pointer;
`
